import { alpha, Button, styled } from "@mui/material";


export const BglCloseButtonBase = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  color: theme.palette.error.contrastText,
  ":hover" : {
    backgroundColor: theme.palette.error.dark,
    borderColor: theme.palette.error.dark
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.error.main, 0.25)
      : alpha(theme.palette.error.main, 0.18),
    borderColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.error.main, 0.45)
      : alpha(theme.palette.error.main, 0.3),
    color: theme.palette.mode === 'dark'
      ? alpha(theme.palette.error.contrastText, 0.7)
      : theme.palette.action.disabled,
    boxShadow: 'none'
  },
  textTransform : 'none'
}))

export const BglPrimaryButtonBase = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  ":hover" : {
    backgroundColor: theme.palette.primary.dark,
    borderColor: theme.palette.primary.dark
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.main, 0.25)
      : alpha(theme.palette.primary.main, 0.18),
    borderColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.main, 0.45)
      : alpha(theme.palette.primary.main, 0.3),
    color: theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.contrastText, 0.7)
      : theme.palette.action.disabled,
    boxShadow: 'none'
  },
  textTransform : 'none'
}))

export const BglSecondaryButtonBase = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  border: `1px solid ${theme.palette.secondary.light}`,
  borderRadius: 8,
  boxShadow: 'none',
  ":hover" : {
    backgroundColor: theme.palette.secondary.dark,
    borderColor: theme.palette.secondary.dark,
    color: theme.palette.primary.contrastText
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.secondary.main, 0.25)
      : alpha(theme.palette.secondary.main, 0.18),
    borderColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.secondary.light, 0.45)
      : alpha(theme.palette.secondary.light, 0.3),
    color: theme.palette.mode === 'dark'
      ? alpha(theme.palette.secondary.contrastText, 0.7)
      : theme.palette.action.disabled,
    boxShadow: 'none'
  },
  textTransform : 'none'
}))

export const BglPrimaryOutlinedButtonBase = styled(Button)(({theme}) => ({
  color: theme.palette.primary.main,
  border: '1px solid',
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.primary.main + '20',
  ":hover" : {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main + '40'
  },
  "&.Mui-disabled": {
    color: theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.main, 0.5)
      : alpha(theme.palette.primary.main, 0.4),
    borderColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.main, 0.3)
      : alpha(theme.palette.primary.main, 0.25),
    backgroundColor: 'transparent',
    border: '1px solid !important'
  },
  textTransform : 'none'
}))

export const BglSecondaryOutlinedButtonBase = styled(Button)(({theme}) => ({
  color: theme.palette.success.dark,
  border: '1px solid',
  borderColor: theme.palette.success.light,
  backgroundColor: theme.palette.success.light + '20',
  ":hover" : {
    borderColor: theme.palette.success.light,
    backgroundColor: theme.palette.success.light + '40'
  },
  "&.Mui-disabled": {
    color: theme.palette.mode === 'dark'
      ? alpha(theme.palette.success.light, 0.3)
      : alpha(theme.palette.success.light, 0.6),
    borderColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.success.light, 0.5)
      : alpha(theme.palette.success.light, 0.4),
    backgroundColor: 'transparent',
    border: '1px solid !important'
  },
  textTransform : 'none'
}))

export const BglCloseOutlinedButtonBase = styled(Button)(({theme}) => ({
  color: theme.palette.error.main,
  border: '1px solid',
  borderColor: theme.palette.error.main,
  backgroundColor: theme.palette.error.main + '20',
  ":hover" : {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.main + '40'
  },
  "&.Mui-disabled": {
    color: theme.palette.mode === 'dark'
      ? alpha(theme.palette.error.main, 0.5)
      : alpha(theme.palette.error.main, 0.4),
    borderColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.error.main, 0.3)
      : alpha(theme.palette.error.main, 0.25),
    backgroundColor: 'transparent',
    border: '1px solid !important'
  },
  textTransform : 'none'
}))

// ----------------------LARGE BUTTONS --------------------------------------

export const BglPrimaryButton = (props : any) => {
  return (
    <BglPrimaryButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}
export const BglSecondaryButton = (props : any) => {
  return (
    <BglSecondaryButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}

export const BglCloseButton = (props : any) => {
  return (
    <BglCloseButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}

// -----------------LARGE OUTLINED BUTTONS -------------------------------------

export const BglPrimaryOutlinedButton = (props : any) => {
  return (
    <BglPrimaryOutlinedButtonBase
    size="large" 
    variant="outlined"
    {...props}/>
  )
}

// ----------------------SMALL BUTTONS --------------------------------------

export const BglPrimarySmallButton = (props : any) => {
  return (
    <BglPrimaryButtonBase
    size="small"
    variant="contained"
    {...props}/>
  )
}

export const BglSecondarySmallButton = (props : any) => {
  return (
    <BglSecondaryButtonBase
    size="small"
    variant="contained"
    {...props}/>
  )
}

export const BglCloseSmallButton = (props : any) => {
  return (
    <BglCloseButtonBase
    size="small"
    variant="contained"
    {...props}/>
  )
}

// -----------------SMALL OUTLINED BUTTONS -------------------------------------

export const BglPrimaryOutlinedSmallButton = (props : any) => {
  return (
    <BglPrimaryOutlinedButtonBase
      size="small"
      variant="outlined"
      {...props}/>
  )
}

export const BglSecondaryOutlinedSmallButton = (props : any) => {
  return (
    <BglSecondaryOutlinedButtonBase
      size="small"
      variant="outlined"
      {...props}/>
  )
}

export const BglCloseOutlinedSmallButton = (props : any) => {
  return (
    <BglCloseOutlinedButtonBase
      size="small"
      variant="outlined"
      {...props}/>
  )
}
